import { render, staticRenderFns } from "./JoinVIP.vue?vue&type=template&id=f5ba156c&scoped=true"
import script from "./JoinVIP.vue?vue&type=script&lang=js"
export * from "./JoinVIP.vue?vue&type=script&lang=js"
import style0 from "./JoinVIP.vue?vue&type=style&index=0&id=f5ba156c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ba156c",
  null
  
)

export default component.exports